import categories from './categories';
import search from './search';

export default function () {
    categories();
    search();
}
